import { gql } from '@/__generated__';

export const productModalDocument = gql(/* GraphQL */ `
  query ProductModal($where: ProductWhereUniqueInput!) {
    product(where: $where) {
      id
      code
      name
      description
      price
      location
      image
      active
      canRemove
      liveId
      variants {
        id
        stock
        attributes {
          id
          name
          value
        }
        _count {
          lines
        }
      }
    }
  }
`);

export const productDocument = gql(/* GraphQL */ `
  query Product(
    $where: ProductWhereUniqueInput!
    $variantsOrdersBy: [ProductVariantOrderByWithRelationInput!]
  ) {
    product(where: $where) {
      id
      name
      code
      description
      location
      image
      price
      active
      canRemove
      reservations {
        id
      }
      variants(orderBy: $variantsOrdersBy) {
        id
        stock
        attributes {
          id
          name
          value
        }
        lines {
          id
          price
        }
        reservations {
          id
          name
        }
      }
      live {
        id
        description
      }
    }
  }
`);
